import React from "react";

function Footer() {
    return (
        <div>
            <footer class="text-center text-white fixed-bottom" style={{ backgroundColor: "#21081a", marginTop: "20px", padding: "10px" }} >

                <div class="text-center p-3" style={{ backgroundColor: "black" }}>
                    © 2021 Copyright:
                    <a class="text-white" href="/">Aadhar gaur</a>
                </div>

            </footer>
        </div>
    )
}



export default Footer;